import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-unauthorized-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './unauthorized-layout.component.html',
  styleUrl: './unauthorized-layout.component.scss',
})
export class UnauthorizedLayoutComponent {}
